import React from "react";
import AirportTermsOfServiceDialog from "@app.automotus.io/components/AirportTermsOfServiceDialog";
import { useUserProfile, useTermsOfService, useActivePayee } from "@app.automotus.io/components/hooks";
import { GSP_TOS_VERSION } from "common/constants";

/**
 * Blocking gate that shows the airport Terms of Service dialog when a GSP airport
 * account user has not yet accepted the Terms of Service.
 */
export const TosGate: React.FC = () => {
  const { userProfile } = useUserProfile();
  const { accept, loading } = useTermsOfService({});
  const { activePayee } = useActivePayee();

  const isGspUser = activePayee?.payeeAccountId === process.env.REACT_APP_GSP_AIRPORT_ACCOUNT_ID;
  const shouldShowTosDialog = !loading && isGspUser && userProfile?.tosAcceptedVersion !== GSP_TOS_VERSION;

  const handleAgree = async () => {
    if (loading) {
      return;
    }
    await accept();
  };

  return (
    <AirportTermsOfServiceDialog
      open={shouldShowTosDialog}
      onClickAgree={handleAgree}
      description="To continue using CurbPass, please review and accept the airport's"
      LinkProps={{
        href: `${process.env.REACT_APP_ASSET_ENDPOINT}/documents/gsp-airport-terms-and-conditions.pdf`,
        target: "_blank",
      }}
    />
  );
};

export default TosGate;
